import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import VueCookies from 'vue-cookies';

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/fonts/fonts.scss'


// Import the CSS or use your own!
import Toast,{ POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";


const app = createApp(App);

//app.config.globalProperties.base_url = 'http://localhost/consero/API/api.php?action=';
app.config.globalProperties.base_url = 'https://heybournepark.qtcloud.co.uk/API/api.php?action=';

//app.config.globalProperties.Image_url = 'http://localhost/consero/';
app.config.globalProperties.Image_url = 'https://heybournepark.qtcloud.co.uk/';

const options = {
    position: POSITION.TOP_RIGHT,
    timeout: 2000 
  };


app.use(router);
app.use(VueCookies, { expire: "0"});

app.use(Toast, options);

app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBtGPJeKV8bZQuM73Yr97Q_FNKBqEnkDJ4',
        libraries: 'places',
    },
    autobindAllEvents: true,
})

app.use(VueViewer, {
    defaultOptions: {
      zIndex: 1000050
    }
  });


app.mount('#app');
